export function formatPhoneNumber(phoneNumber: string) {
  const phoneNumberInDigits = phoneNumber.replace(/\D/g, '')

  // Want to tolerate strange formats like "1 (612) 539-0582" etc.
  const length = phoneNumberInDigits.length
  const before10 = phoneNumberInDigits.substring(0, length - 10)
  const last10 = phoneNumberInDigits.substring(length - 10, length)

  return length === 10
    ? phoneNumberInDigits.slice(0, 3) + '-' + phoneNumberInDigits.slice(3, 6) + '-' + phoneNumberInDigits.slice(6, 10)
    : before10 + '-' + last10.slice(0, 3) + '-' + last10.slice(3, 6) + '-' + last10.slice(6, 10)
}
